export const GET_PAGINATION_BRANDS = 'GET_PAGINATION_BRANDS';
export const GET_ALL_BRANDS = 'GET_ALL_BRANDS';
export const ADD_MORE_BRANDS = 'ADD_MORE_BRANDS';
export const SET_THERE_ARE_MORE_BRANDS = 'SET_THERE_ARE_MORE_BRANDS';
export const SET_IS_LOADING_GET_ALL_BRANDS = 'SET_IS_LOADING_GET_ALL_BRANDS';
export const SET_IS_LOADING_GET_PAGINATION_BRANDS =
  'SET_IS_LOADING_GET_PAGINATION_BRANDS';
export const SET_BODY_SEARCH = 'SET_BODY_SEARCH';
export const RESET_BODY_SEARCH = 'RESET_BODY_SEARCH';
